export default __webpack_public_path__ + "static/media/code1.ece9ecf5.png";